import { useAppContext } from "../../AppProvider";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon";
import { faCube, faQ, faWeightHanging } from "../../utilities/fontawesomeIcons";
import { useDetailsIndexContext } from "../Shipments/providers/hooks";
import { getParcelsFooterGridLayout } from "./Layout";
import { createParcelsFooterGridVars } from "./Layout/gridVars";
import "./Layout/index.scss";

export const ParcelFooter = () => {
  const { dictionary, display } = useAppContext();
  const { data } = useDetailsIndexContext();

  const footerLayout = getParcelsFooterGridLayout(display);
  const footerStyle = createParcelsFooterGridVars(footerLayout);

  return (
    <>
      <div
        data-grid-template="parcelsFooter"
        className="d-grid gap-2 mt-3 px-2"
        style={footerStyle}
      >
        <div data-grid-area="totalQuantity">
          <label className="label-2">
            {dictionary.dimensions.total_quantity}
          </label>
          <InputBoxIcon
            name="parcels"
            value={data.parcels || "-"}
            type="positive-integer-number"
            disabled
            className="fw-bold"
            icon={faQ}
          />
        </div>
        <div data-grid-area="totalWeight">
          <label className="label-2">
            {dictionary.dimensions.total_weight} (Kg)
          </label>
          <InputBoxIcon
            name="weight"
            value={data.weight || "-"}
            type="positive-number"
            icon={faWeightHanging}
            disabled
            className="fw-bold"
          />
        </div>
        <div data-grid-area="totalVolume">
          <label className="label-2">
            {dictionary.dimensions.total_volume} (m<sup>3</sup>)
          </label>
          <InputBoxIcon
            name="volume"
            value={data.volume || "-"}
            type="positive-number"
            precision={6}
            icon={faCube}
            disabled
            className="fw-bold"
          />
        </div>
      </div>
    </>
  );
};
